import type React from "react";

import { Container, Paper, Typography, useTheme } from "@mui/material";
import { Tabs, type TabsProps } from "antd";
import { AppBar } from "components";
import FontManagerTab from "components/FontManagerTab";
import FontReportsTab from "components/FontsReportTab";
import SystemConfigTab from "components/SystemConfigTab";
import { useState } from "react";
import { StyledTabsContainer } from "./styles";

// Componente principal do Painel de Controle
const ControlPanel: React.FC = () => {
  const [currentTab, setCurrentTab] = useState<string>("1");
  const theme = useTheme();

  const items: TabsProps["items"] = [
    {
      key: "1",
      label: "Fontes",
      children: <FontManagerTab />,
    },
    {
      key: "2",
      label: "Monitoramento",
      children: <FontReportsTab />,
    },
    // {
    //   key: "3",
    //   label: "Configurações do Sistema",
    //   children: <SystemConfigTab />,
    // },
  ];

  return (
    <>
      <AppBar />
      <Container
        sx={{
          minWidth: "90vw",
          minHeight: "100vh",
          pt: 10,
          pb: 4,
        }}
      >
        <Paper
          sx={{
            p: 4,
            mb: 3,
            borderRadius: "12px",
            boxShadow: "0 4px 12px rgba(0,0,0,0.05)",
          }}
        >
          <Typography
            component="p"
            variant="h4"
            color="primary"
            sx={{
              fontWeight: 600,
              position: "relative",
              marginBottom: "24px",
              "&:after": {
                content: '""',
                position: "absolute",
                bottom: -8,
                left: 0,
                width: 60,
                height: 3,
                backgroundColor: theme.palette.primary.main,
                borderRadius: 4,
              },
            }}
          >
            Painel de Controle
          </Typography>

          {/* Tabs */}
          <StyledTabsContainer>
            <Tabs
              defaultActiveKey={currentTab}
              items={items}
              onChange={setCurrentTab}
              size="large"
            />
          </StyledTabsContainer>
        </Paper>
      </Container>
    </>
  );
};

export default ControlPanel;
